/** Display helpers for the Exit clicks surface. These are counts and a leak
 * percentage; there is no currency on this surface. */

/**
 * Format a leak RATE (a fraction, e.g. 0.9) as a percentage to 1 dp (-> "90.0%").
 * A null rate (no matured clicks yet) renders as "n/a" so a fresh store reads as
 * "still maturing", never as a 0% (or any%) leak.
 */
export const formatRate = (rate: number | null): string =>
  rate == null ? 'n/a' : `${(rate * 100).toFixed(1)}%`;
